import { Component, OnInit, ViewChild } from '@angular/core';
import { LookupService } from '../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../services/lookups/lookupadmin.service';
import { Location } from '../../../models/user.model';
import { SelectItem } from 'primeng/api';
import { CountryDetailComponent } from './country-detail/country-detail.component';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {
  countries: Location[];
  locationNames:SelectItem[];
  parentLocationNames:SelectItem[];
  isActiveList:SelectItem[];
  displayCountryDetailDlg:boolean;
  @ViewChild(CountryDetailComponent) countryDetail: CountryDetailComponent;
  constructor(private lookupService: LookupService, private lookupAdminService: LookupAdminService) {}

  ngOnInit() {
    this.LoadAllCountries();
    
  }

  private LoadAllCountries() {
    this.lookupAdminService.getAllCountries$().subscribe(data => {
      this.countries = data;
      this.countries.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      this.locationNames = this.lookupAdminService.GetUniqueValues(this.countries.map(p=>p.locationName));
      this.parentLocationNames = this.lookupAdminService.GetUniqueValues(this.countries.map(p=>p.parentLocationName));
      var isActives = new Array<SelectItem>();
      isActives.push({ label: "Yes", value:true});
      isActives.push({ label: "No", value:false});
      this.isActiveList = isActives;
    });
  }
  
  ShowHideCountryDetailDialog(isDisplay:boolean)
  {
    this.displayCountryDetailDlg = isDisplay;
    //TODO: Add behaviour subject in the services to manage refresh of the table.
    //this.LoadAllCountries();
    
  }
  showCountryDetailDialog(location:any)
  {
    this.countryDetail.showCountryDetailDialog(location);
    this.ShowHideCountryDetailDialog(true);
  }
  RefreshDataSource(isReload:boolean)
  {
    if(isReload)
     this.LoadAllCountries();
  }


}
